/**
 * ``/order/<id>`` (singular) was never a route — it fell through to Not Found, and the notifications list linked to
 * it. Send it to the real order page. Purely additive: no existing route changes.
 */
import { Navigate, useParams } from "react-router-dom";

export default function LegacyOrderRedirect() {
    const { id } = useParams();
    return <Navigate to={`/orders/${encodeURIComponent(id)}`} replace />;
}
